// src/Components/Common/Icons.js

import React from 'react';
// Import the icons you need from the Font Awesome set
import { 
  FaShoppingCart, 
  FaUser, 
  FaPlusCircle, 
  FaMinusCircle, 
  FaTrash 
} from "react-icons/fa";

// Re-export them with the same names you used before for seamless integration
export const ShoppingCartIcon = (props) => <FaShoppingCart {...props} />;
export const UserIcon = (props) => <FaUser {...props} />;
export const PlusIcon = (props) => <FaPlusCircle {...props} />;
export const MinusIcon = (props) => <FaMinusCircle {...props} />;
export const TrashIcon = (props) => <FaTrash {...props} />;